import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";
import { EntDirectoryInfoName } from "../directoryInfoName";

export class EntPesticides {
  id: number | null = null;
  periodStart: string | null = null;
  periodEnd: string | null = null;
  territorialUnits: EntTerritorialsUnits | null = null;
  pesticideDetails: PesticideDetails[] | null = null;

  territorialUnitId?: number | null = null;
}

export class PesticideDetails {
  key: number | null = null;
  id: number | null = null;
  pesticidesType?: EntDirectoryInfoName | null = null;
  neededTonnes: number | null = null;
  suppliedTonnes: number | null = null;
  supplyPercent?: number | null = null;

  pesticidesTypeId?: number | null = null;
}